<template>
    <div class="d-flex wfh-custom-select-item justify-content-between">
        <div @click="selectItem" style="width: 90%;cursor: pointer;">{{selectorText}}</div>
        <i class="fa fa-check pr-1" v-if="selected"></i>
        <button class="btn btn-link" style="padding: 0 !important;" type="button" v-else @click="editItem">
          <img src="/images/pencil_icon.svg" />
        </button>
    </div>
</template>

<script>
    export default {
        props: ['selectorText', 'selected'],

        methods: {
            selectItem () {
                this.$emit('selectItem')
            },

            editItem () {
                this.$emit('manageItem')
            },
        },
    }
</script>

<style scoped lang="scss">
    .wfh-custom-select-item {
        padding: 4px 15px;
        height: 40px;
        align-items: center;

        rect {
            fill: #000;
        }

        i {
            color: #000;
        }

        &:hover {
            color: #fff;
            background-color: #3592ff;

            i {
                color: #fff;
            }

            rect {
                fill: #fff;
            }
        }
    }
</style>
